import PropTypes from 'prop-types';
import React from 'react';

import { createBEM } from '../../../lib/utils/css';

import './RadioButton.scss';

class RadioButton extends React.Component {
  static propTypes = {
    isChecked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    name: PropTypes.string,
    labelTextPrimary: PropTypes.any,
    labelTextSecondary: PropTypes.any,
    isWhite: PropTypes.bool,
    qaTag: PropTypes.string,
  };

  renderLabelText(text, isPrimary) {
    const classes = createBEM('RadioButton__label__text', {
      primary: isPrimary,
      secondary: !isPrimary,
    });
    return <div className={classes}>{text}</div>;
  }

  renderRadioInput() {
    return (
      <input
        className='RadioButton__input'
        type='radio'
        checked={this.props.isChecked}
        onChange={this.props.onChange}
        value={this.props.value}
        name={this.props.name}
        data-qa={this.props.qaTag}
      />
    );
  }

  render() {
    const classes = createBEM('RadioButton', {
      white: this.props.isWhite,
    });
    return (
      <div className={classes}>
        <label className='RadioButton__label'>
          {this.renderRadioInput()}
          <div className='RadioButton__label__text__container'>
            {this.renderLabelText(this.props.labelTextPrimary, true)}
            {this.renderLabelText(this.props.labelTextSecondary)}
          </div>
        </label>
      </div>
    );
  }
}

export default RadioButton;
